import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
//存储公共状态
  state: {
    dlMark: JSON.parse(localStorage.getItem('zqW')) || null,
  },
  //修改状态的方法
  mutations: {
  },
  actions: {
  }
});

//导出store实例
export default store;
